import {HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable()
export class DatasaveService {

  public url: string;

  constructor(private httpClient: HttpClient) {
    this.url = environment.backend;
  }

  saveVisitData(data) {
    this.httpClient
      .post(this.url + '/datasave/visit', {data})
      .subscribe(
        (response) => {
          return;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  saveMailData(data) {
    this.httpClient
      .post(this.url + '/datasave/mail', {data})
      .subscribe(
        (response) => {
          return;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  saveOpenedPopin(data) {
    this.httpClient
      .post(this.url + '/datasave/opened', {data})
      .subscribe(
        (response) => {
          return;
        },
        (error) => {
          console.log(error);
        }
      );
  }
}
